import { useEffect, useRef } from 'react';
import { useAuth } from 'app/features/auth/useAuth';
import { Mixpanel } from '../vendors/mixpanel';

export const useMixpanelIdentify = () => {
	const { isAuthenticated, org } = useAuth();
	const hasIdentified = useRef(false);

	useEffect(() => {
		if (isAuthenticated && org?.name && !hasIdentified.current) {
			Mixpanel.waitForAnalytics(() => {
				Mixpanel.identify(org.name);
				hasIdentified.current = true;
			});
		}
	}, [isAuthenticated, org?.name]);
};